export default "__VITE_ASSET__CjlBkn6P__"